<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <EditSurvey />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EditSurvey from "./components/EditSurvey";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    EditSurvey,
    // ProjectsTable,
  },
};
</script>
